const state = {
  authenticated: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['authenticated'] : '',
  profile: localStorage.getItem('user')
    ? JSON.parse(localStorage.getItem('user'))['profile']
    : {
        email: '',
        phone: '',
        first_name: '',
        last_name: '',
        username: '',
        address: '',
        permission_type: 3,
      },
  maps: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['maps'] : [],
  access_token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['access_token'] : '',
  refresh_token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['refresh_token'] : '',
  user_id: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['user_id'] : '',
  permissions:
    localStorage.getItem('permissions') && localStorage.getItem('permissions') !== 'undefined'
      ? JSON.parse(localStorage.getItem('permissions'))
      : [],
  domain: localStorage.getItem('domain') ? localStorage.getItem('domain') : '/',
  app_url: localStorage.getItem('app_url') ? localStorage.getItem('app_url') : '/',
  env: localStorage.getItem('env') ? localStorage.getItem('env') : null,
  tag_settings:
    localStorage.getItem('tag_settings') && localStorage.getItem('tag_settings') !== 'undefined'
      ? JSON.parse(localStorage.getItem('tag_settings'))
      : {},
  notification_options:
    localStorage.getItem('notification_options') && localStorage.getItem('notification_options') !== 'undefined'
      ? JSON.parse(localStorage.getItem('notification_options'))
      : {},
  notification_alarms:
    localStorage.getItem('notification_alarms') && localStorage.getItem('notification_alarms') !== 'undefined'
      ? JSON.parse(localStorage.getItem('notification_alarms'))
      : {},
  icon_type: localStorage.getItem('icon_type') ? JSON.parse(localStorage.getItem('icon_type')) : 1,
  groups: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user'))['groups'] : null,
  tile: localStorage.getItem('tile') ? Number(localStorage.getItem('tile')) : 0,
};

const mutations = {
  async set_user(state, payload) {
    state.authenticated = payload.status;
    state.access_token = payload.token;
    state.refresh_token = payload.refresh_token;
    state.profile = payload.profile;
    state.maps = payload.maps;
    state.groups = payload.groups;
    state.user_id = payload.user_id;
    state.tag_settings = payload.map_settings;
    state.notification_options = payload.notification_options;
    state.notification_alarms = payload.notification_alarms;
    state.tile = payload.tile;

    localStorage.setItem('tag_settings', JSON.stringify(payload.map_settings));
    localStorage.setItem('notification_options', JSON.stringify(payload.notification_options));
    localStorage.setItem('notification_alarms', JSON.stringify(payload.notification_alarms));
    localStorage.setItem('user', JSON.stringify(state));
  },
  init_user_store(state) {
    if (localStorage.getItem('user_store')) {
      state.details = JSON.parse(localStorage.getItem('user_store')).details;
    }
  },
  setPermission(state, permissions) {
    state.permissions = permissions;
    localStorage.setItem('permissions', JSON.stringify(permissions));
  },
  update_profile(state, payload) {
    state.profile = payload;
    let storage = JSON.parse(localStorage.getItem('user'));
    storage['profile'] = payload;
    localStorage.setItem('user', JSON.stringify(storage));
  },
  set_url(state, urls) {
    state.domain = urls.domain;
    state.app_url = urls.app_url;
    localStorage.setItem('domain', state.domain);
    localStorage.setItem('app_url', state.app_url);
  },
  set_env(state, payload) {
    state.env = payload;
    localStorage.setItem('env', state.domain);
  },
  set_tag_settings(state, payload) {
    state.tag_settings = payload;
    localStorage.setItem('tag_settings', JSON.stringify(payload));
  },
  set_notification_options(state, payload) {
    state.notification_options = payload;
    localStorage.setItem('notification_options', JSON.stringify(payload));
  },
  set_notification_alarms(state, payload) {
    state.notification_alarms = payload;
    localStorage.setItem('notification_alarms', JSON.stringify(payload));
  },
  set_icon_type(state, payload) {
    state.icon_type = payload;
    localStorage.setItem('icon_type', JSON.stringify(payload));
  },
  set_selected_map_tile(state, payload) {
    state.tile = payload;
    localStorage.setItem('tile', JSON.stringify(payload));
  },
};

const getters = {
  user() {
    return state;
  },
  tag_settings() {
    return state.tag_settings;
  },
  notification_options() {
    return state.notification_options;
  },
  notification_alarms() {
    return state.notification_alarms;
  },
  permissions() {
    return state.permissions;
  },
  API_URL() {
    return state.app_url;
  },
  DOMAIN() {
    return state.domain;
  },
  STORAGE_DOMAIN() {
    let domain = localStorage.getItem('domain');
    return domain;
  },
  env() {
    return state.env;
  },
  icon_type() {
    return state.icon_type;
  },
  groups() {
    return state.groups;
  },
  selected_map_tile() {
    return state.tile;
  },
  access_token() {
    return state.access_token;
  },
  refresh_token() {
    return state.refresh_token;
  },
};

const actions = {
  set_user({ commit }, payload) {
    commit('set_user', payload);
  },
  init_user_store({ commit }, payload) {
    commit('init_user_store', payload);
  },
  setPermission({ commit }, payload) {
    commit('setPermission', payload);
  },
  update_profile({ commit }, payload) {
    commit('update_profile', payload);
  },
  set_url({ commit }, payload) {
    commit('set_url', payload);
  },
  set_env({ commit }, payload) {
    commit('set_env', payload);
  },
  set_notification_options({ commit }, payload) {
    commit('set_notification_options', payload);
  },
  set_notification_alarms({ commit }, payload) {
    commit('set_notification_alarms', payload);
  },
  set_icon_type({ commit }, payload) {
    commit('set_icon_type', payload);
  },
  set_selected_map_tile({ commit }, payload) {
    commit('set_selected_map_tile', payload);
  },
};

export default {
  state,
  mutations,
  getters,
  actions,
};
